import { render, staticRenderFns } from "./SignupPage.vue?vue&type=template&id=371f6822&scoped=true"
import script from "./SignupPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./SignupPage.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./SignupPage.vue?vue&type=style&index=0&id=371f6822&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371f6822",
  null
  
)

export default component.exports